// Module
var code = "<template> <a if.bind=\"task && hasRoute\" href.bind=\"route\" click.capture=\"handleLinkClickCapture()\" ess-tooltip.bind=\"'ui:actions.openOn' | tr: { what: label, item: task.case.number }\" ess-icon.bind=\"icon\" ess-focusable></a> </template> ";
// Exports
module.exports = code;